import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/accordion';
import { ChipsModule } from 'primeng/chips';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SimpleTableModule } from 'src/app/components/table/simple-table/simple-table.modules';
import { PipeModule } from 'src/app/pipes/pipe.module';
import { GenericDesplegableModule } from '../../components/deplegable/generic-dropdown/generic-dropdown.module';

import { OfertasPackListComponent } from './ofertas-pack-list/ofertas-pack-list.component';
import { AppOfertasPacksRoutingModule } from './app.ofertas-packs.routes';
import { UserLoginService } from '@/app/services/UserLogin/UserLoginService';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ButtonModule,
    TabViewModule,
    TableModule,
    DialogModule,
    DropdownModule,
    InputTextModule,
    MultiSelectModule,
    CalendarModule,
    RadioButtonModule,
    InputSwitchModule,
    ConfirmDialogModule,
    CheckboxModule,
    AccordionModule,
    ChipsModule,
    AutoCompleteModule,
    SimpleTableModule,
    GenericDesplegableModule,
    PipeModule,
    AppOfertasPacksRoutingModule

  ],
  declarations: [OfertasPackListComponent],
  exports: [OfertasPackListComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    MessageService,
    ConfirmationService,
    UserLoginService,
  ]
})
export class AppOfertasPacksModule { }
